import React from "react";
import PropTypes from "prop-types";
import { getLinkToProject } from "../../common/util/pathUtils";

const SingleColumn = ({ project, showLearnMore }) => {
    const linkToProject = getLinkToProject(project.code);

    return <div className="mw-100 center text-left bg-white h-100p prjct">
				<img className="mw-100 fix-height" src={project.thumbnailImageUrl} alt=""/>
				<div className="px-3 pb-4">
					<p className="small color-light mb-0">{project.locationDescription}</p>
					<h6 className="font-bold">{project.name}</h6>
					<p className="small-14 mt-2">{project.shortDescription}</p>
					{showLearnMore &&
						<a href={linkToProject} className="d-flex align-items-center mt-4">
						<small className="color-orange font-medium mr-1">Learn more</small>
							<img src={`https://res.cloudinary.com/carbonclick/image/upload/v1635160707/Enterprise/ACI-LAC/right-arrow_lgwc74.svg`} alt="arrow-right"/>
						</a>
					} 
				</div>
			</div>
} 

SingleColumn.propTypes = {
    project: PropTypes.object,
    showLearnMore: PropTypes.bool
}

export default SingleColumn;